module.exports = __webpack_public_path__ + "static/media/chart-line-down.e99e986f.svg";